module.exports = __webpack_public_path__ + "10c7056ce63d5e949144c1e8d39c3a8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/schalen/Ruoff_091114x0046.jpg
// module id = 375
// module chunks = 0